export default __webpack_public_path__ + "static/media/mantlechicken.f6bf0fca.jpg";